import { Component, OnInit, ElementRef, ViewChild, TemplateRef, Input } from '@angular/core';
import { UserManagerService } from '../../../shared/providers/user-manager.service';
import { IUserDetails } from '../../../shared/models/UserDetailsOutputModel';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { RestService } from '../../../shared/providers/rest.service'
import { IUserInput } from '../../../shared/models/UserInputModel';
import { ILookUp } from '../../../shared/models/LookUpOutputModel';

import { IUserCreationResponseModel } from '../../../shared/models/UserCreationResponseModel';
import { FileUploadService } from '../../../shared/providers/fileupload.service';
import { IFileUpload } from '../../../shared/models/fileupload';
import { ValidationService } from '../../../shared/providers/validation.service';
import { ToastService } from '../../../shared/providers/toast.service'
import { CommonService } from '../../../shared/providers/common.service'
import { UserStatus } from '../../../shared/enum/enum';
import { LoaderService } from '../../../shared/providers/loader.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UserRole } from '../../../shared/enum/enum';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { AuthService } from '../../../shared/auth/auth.service';
import { IResponseModel } from '../../../shared/models/ResponseModel';
import { PropertyManagementService } from '../../../shared/providers/property-management.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IForgotPassword } from '../../../shared/models/forgotpasswordInput';
import { IAddStandardUserModel } from '../../../shared/models/AddStandardUserModel';
import { IStandardUserProperties } from '../../../shared/models/StandardUserProperties';


@Component({
  selector: 'standarduser-add',
  templateUrl: './standarduser-add.component.html',

})
export class StandardUserAddComponent implements OnInit {

  lookupList: ILookUp[];
  userInputModel = {} as IUserInput;
  userCreationResponseModel = {} as IUserCreationResponseModel;
  DefaultIndexCount: number = 0;
  userGuid: string = "";
  userDetailsOutput = {} as IUserDetails;
  PrincipalUserGuid: string = '0000';
  IsEditMode: boolean = false;
  IsAdd: boolean = false;
  @ViewChild('profilePic') profilePic: ElementRef;
  pageHeading = "Add Standard User Details";
  userRole = UserRole;
  private newAttribute: any = {};
  imageIdToDelete: number;
  deleteTask: string;
  deleteTaskId: number;
  modalRef: BsModalRef;
  modalRefGrandAccess: BsModalRef;
  userId: number = 0;
  isExpiryDateValidate: number[] = [];
  loggedUserDetails: any;
  userEmailID: string;
  header = "Add";
  @ViewChild('addProperty') accept: TemplateRef<null>;
  IsBlocked: boolean = false;
  IsDeleted: boolean = false;
  responseModel = {} as IResponseModel;
  fileUploadType: string = "single";
  inputFileUpload = {} as IFileUpload;
  modalRefBov: BsModalRef;
  selectedpropertyIds = [];
  properties = [];
  addStandardUserModel = {} as IAddStandardUserModel;
  addedProperties: Array<IStandardUserProperties> = [];
  IsUserValid: boolean = false;
  @ViewChild('GrandAccess') grandAccess: TemplateRef<any>;

  constructor(private _restService: RestService, private _userManagerService: UserManagerService, private _fileUploadService: FileUploadService, private router: Router, public validationService: ValidationService,
    private activatedRoute: ActivatedRoute, private _toastService: ToastService, private _commonService: CommonService, protected loaderService: LoaderService, private modalService: BsModalService,
    public authService: AuthenticationService, public _validationService: ValidationService, private _auth0: AuthService, private _propertyManagementService: PropertyManagementService) {

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params['user'] != '' && params['user'] != null && params['user'] != undefined) {
        this.userGuid = params['user'];
      }
      if (params['PrincipalUserGuid'] != '' && params['PrincipalUserGuid'] != null && params['PrincipalUserGuid'] != undefined) {
        this.PrincipalUserGuid = params['PrincipalUserGuid'];
      }
      if (this.userInputModel.ProfilePicPath === undefined || this.userInputModel.ProfilePicPath === null || this.userInputModel.ProfilePicPath.trim().length <= 0) {
        this.userInputModel.ProfilePicPath = '/../../../assets/img/default-profile-img.png'
      }

    });
  }
  result = [];

  selectedFiles: string[] = [];
  clearFiles: number = 0;

  selectedFilesListEmitter(selectedFilesListEmitter: string[]) {
    this.selectedFiles = selectedFilesListEmitter;
  }

  selectedFilePathEmitter(selectedFilePathEmitter: any) {
    this.profilePic.nativeElement.src = selectedFilePathEmitter;
  }

  setUploadDefaultValues() {
    this.inputFileUpload.fileCategoryId = 251;
    this.inputFileUpload.id = 0;
    this.inputFileUpload.objectId = 0;
    this.inputFileUpload.objectTypeId = 301;
    this.inputFileUpload.documentName = "User Profile Pictuer";
    this.inputFileUpload.type = "Images";
  }
  onKeydown(event) {
    if (event.key === "Enter") {
      this.saveUser();
    }
  }

  getProperties() {
    let principalId = this.userGuid != null && this.userGuid != '' ? this.userGuid : '0000';
    this._propertyManagementService.getPrincipalPortfolioProperties(this.loggedUserDetails.Id, this.PrincipalUserGuid, principalId).subscribe(response => {
      if (response != null && response.length > 0) {
        this.properties = response;
      }
      if (this.userGuid != undefined && this.userGuid != '' && this.userGuid != null) {
        this.loaderService.display(true);
        this._userManagerService.getUserDetails(this.userGuid).subscribe(response => {
          this.userEmailID = response.Email;
          this.userInputModel.UserGuid = this.userGuid;
          this.userInputModel.FirstName = response.FirstName;
          this.userInputModel.LastName = response.LastName;
          this.userInputModel.EmailAddress = response.Email;
          this.userInputModel.PhoneNumber = response.Phoneno;
          this.userInputModel.Address1 = response.Address1;
          this.userInputModel.Address2 = response.Address2;
          this.userInputModel.StateId = response.StateId;
          this.userInputModel.CityId = response.CityId == null ? 0 : response.CityId;
          this.userInputModel.Zip = response.Zip;
          this.userInputModel.UserRoleId = response.UserRoleId;
          this.userInputModel.UserStatus = response.UserStatusId;
          this.userInputModel.ProfilePicPath = response.ProfilePicPath;

          this.userInputModel.Password = '***********************************************************************';

          this.userInputModel.CompanyName = response.CompanyName;
          this.imageIdToDelete = response.ImageId;
          //if (this.imageIdToDelete != null) {
          //  $('.profileupload')[0].hidden = true;
          //}
          //else {
          //  $('.profileupload')[0].hidden = false;
          //}
          this.userId = response.Id;
          this._userManagerService.GetStandardUserProperties(this.userId, this.userGuid).subscribe(res => {
            this.loaderService.display(false);
            this.addedProperties = res.data ? res.data : [];
            if (this.addedProperties.length > 0) {
              this.addedProperties.forEach(s => {

                let property = this.properties.find(p => p.Id == s.PropertyId);
                if (property != undefined) {
                  this.selectedRows.push(property);
                  property.IsChecked = true;
                }
              });
            }
          });

          this.IsEditMode = true;
          this.pageHeading = "Edit User Details";

          if (this.userInputModel.ProfilePicPath === undefined || this.userInputModel.ProfilePicPath === null || this.userInputModel.ProfilePicPath.trim().length <= 0) {
            this.userInputModel.ProfilePicPath = '/../../../assets/img/default-profile-img.png'
          }
        });

      }
      else {
        this.IsAdd = true;
        this.userInputModel.UserStatus = UserStatus.Active;
        this.userInputModel.BrokerageId = null;
      }

      if (this.userInputModel.ProfilePicPath === undefined || this.userInputModel.ProfilePicPath === null || this.userInputModel.ProfilePicPath.trim().length <= 0) {
        this.userInputModel.ProfilePicPath = '/../../../assets/img/default-profile-img.png'
      }
    });
  }

  uploadFiles() {

    this._fileUploadService.uploadFiles(this.inputFileUpload, this.selectedFiles).subscribe(response => {
      this.clearFiles++;
      this.redirectToListingPage();
    });
  }
  wasComplianceBroker = false;
  validatePassword = false;
  ngOnInit() {
    this.authService.isLoggedIn.subscribe(response => {
      if (response) {
        this.loggedUserDetails = this.authService.user;
        this.userInputModel.CreatedById = this.loggedUserDetails.Id;
      }
    });
    this.setUploadDefaultValues();
    this.userInputModel.StateId = 0;
    this.userInputModel.CityId = 0;
    this.userInputModel.UserRoleId = 0;
    this.userInputModel.UserStatus = 0;
    this.userInputModel.PrincipalUserGuid = this.PrincipalUserGuid;
    this.getProperties();
  }

  IsNull(val) {
    if (val == null || val == "0" || val == undefined) {
      return '';
    }
    return val;
  }

  onHomeBreadCrumbClick() {
    this.router.navigateByUrl('/principal-dashboard');
  }

  selectedRows = [];
  onCheckboxChange(event, Id) {
    if (event) {
      let prop = this.properties.find(x => x.Guid == Id);
      this.selectedRows.push(prop);
    }
    else {
      if (this.selectedRows.findIndex(x => x.Guid == Id) > -1) {
        let index = this.selectedRows.findIndex(x => x.Guid == Id);
        this.selectedRows.splice(index, 1);
      }
    }
  }

  selectAll = false;
  AddProperty(template: TemplateRef<any>, classes: any) {
    //this.selectedRows = [];
    this.selectAll = false;

    this.modalRefBov = this.modalService.show(template, { class: classes });
  }

  onSelectAll(event) {
    if (event.target.checked) {
      this.selectOrUnSelectAll(true);
    }
    else {
      this.selectOrUnSelectAll(false);
    }
  }

  selectOrUnSelectAll(trueOrfalse) {
    this.properties.forEach(item => {
      item.IsChecked = trueOrfalse;
      if (trueOrfalse) {
        // if true then push all selected items into selectedRows collection
        let selectedRow = this.selectedRows.find(x => x.Guid == item.Guid);
        if (selectedRow == undefined || selectedRow == null) {
          this.selectedRows.push(item);
        }
      }
      else {
        // if false then current item from the selected row collection
        this.selectedRows.splice(this.selectedRows.findIndex(x => x.Guid == item.Guid), 1);
      }
    });
    if (!trueOrfalse) {
      this.selectAll = false;
    }
  }

  AddPropertyToStandardUser() {
    if (this.selectedRows != null && this.selectedRows.length > 0) {
      this._toastService.addToast({ title: 'Success', msg: 'Successfully added properties', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
      this.modalRefBov.hide();
    }
    else {
      this._toastService.addToast({ title: 'Error', msg: 'Please select at least one property', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
  }

  firstNameValid: boolean = true;
  lastNameValid: boolean = true;
  emailValid: boolean = true;
  emailvalidation: string = "";
  addPropertyValidation: string = "";
  phoneValid: boolean = true;

  showFNSpecCharVal = false;
  showLNSpecCharVal = false;
  specCharValMsg = '!@#$%^&*()_+\-=\[\]{};"\\|<>\/? not allowed';
  saveUser() {

    this.userInputModel.UserRoleId = this.userRole.Principal;
    this.userInputModel.IsStandardUser = true;
    let IsValid: boolean = true;

    if (this.validationService.IsinValid(this.userInputModel.FirstName)) {
      this.firstNameValid = false;
      this.showFNSpecCharVal = false;
      IsValid = false;
    }
    else {
      if (this.validationService.isSpecialCharacterExist(this.userInputModel.FirstName)) {
        this.firstNameValid = false;
        IsValid = false;
        this.showFNSpecCharVal = true;
      }
      else {
        this.showFNSpecCharVal = false;
        this.firstNameValid = true;
      }

    }

    if (this.validationService.IsinValid(this.userInputModel.LastName)) {
      this.lastNameValid = false;
      this.showLNSpecCharVal = false;
      IsValid = false;
    }
    else {
      if (this.validationService.isSpecialCharacterExist(this.userInputModel.LastName)) {
        this.lastNameValid = false;
        IsValid = false;
        this.showLNSpecCharVal = true;
      }
      else {
        this.showLNSpecCharVal = false;
        this.lastNameValid = true;
      }
    }

    if (this.validationService.IsinValid(this.userInputModel.EmailAddress)) {
      this.emailValid = false;
      IsValid = false;
    }
    else if ((this.validationService.isEmail(this.userInputModel.EmailAddress) == false) && !this.validationService.IsinValid(this.userInputModel.EmailAddress)) {
      this.emailValid = false;
      IsValid = false;
      this.emailvalidation = "invalid Email address";
    }
    else {
      this.emailValid = true;
      this.emailvalidation = "";
    }

    if (this.validationService.IsinValid(this.userInputModel.PhoneNumber)) {
      this.phoneValid = false;
      IsValid = false;
    }
    else {
      this.phoneValid = true;
    }

    if (this.selectedRows.length <= 0) {
      IsValid = false;
      this.addPropertyValidation = "Select at least one property."
    }
    else {
      this.addPropertyValidation = "";
    }

    if (IsValid) {

      if (this.selectedFiles.length > 0) {
        this.loaderService.display(true);
      }

      if (this.userInputModel.EmailAddress) {
        this.userInputModel.DataEntryPropertyIds = []
        this.selectedRows.forEach(s => {
          this.userInputModel.DataEntryPropertyIds.push(s.Id);
        });
        if (!this.IsEditMode) {
          this.loaderService.display(true);
          this.addStandardUserModel.Email = this.userInputModel.EmailAddress;
          this.addStandardUserModel.AssociatedPrincipalId = this.userInputModel.CreatedById;
          this._userManagerService.CheckIfUserExists(this.addStandardUserModel).subscribe(response => {
            this.responseModel = response;
            if (!this.responseModel.IsSuccess) {
              this._userManagerService.createUser(this.userInputModel).subscribe(response => {
                this.userCreationResponseModel = response;
                this.loaderService.display(false);
                if (this.userCreationResponseModel.Success == true) {

                  if (this.selectedFiles.length > 0) {
                    this.inputFileUpload.objectId = this.userCreationResponseModel.Id;
                    this.inputFileUpload.id = this.userCreationResponseModel.Id;
                    this.uploadFiles();
                  }
                  else {
                    this.redirectToListingPage();
                  }
                }
                else {
                  this._toastService.addToast({ title: 'Error Occurred', msg: this.userCreationResponseModel.FailureMessage, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
                }
              });
            }
            else if (this.responseModel.IsSuccess && this.responseModel.ErrorMessage != '') {
              this.properties.forEach(p => {
                p.IsChecked = false;
              });

              this.loaderService.display(false);
              this._toastService.addToast({ title: 'Error Occurred', msg: this.responseModel.ErrorMessage, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
            }
            else {
              if (this.IsUserValid) {
                this.addStandardUserModel.Email = this.userInputModel.EmailAddress;
                this.addStandardUserModel.AssociatedPrincipalId = this.userInputModel.CreatedById;
                this.addStandardUserModel.DataEntryPropertyIds = this.userInputModel.DataEntryPropertyIds;
                this._userManagerService.AddExistingUserAsStandardUser(this.addStandardUserModel).subscribe(response => {
                  this.loaderService.display(false);
                  this._toastService.addToast({ title: 'Success', msg: 'Standard user added successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
                  this.redirectToListingPage();
                });
              }
              else {
                this.loaderService.display(false);
                this.checkDuplicateUser();
              }
            }
          });
        }
        else {
          this.loaderService.display(true)
          this._userManagerService.updateUser(this.userInputModel).subscribe(response => {
            this.userCreationResponseModel = response;
            this.loaderService.display(false)
            if (this.userCreationResponseModel.Success == true) {

              if (this.selectedFiles.length > 0) {
                this.inputFileUpload.objectId = this.userCreationResponseModel.Id;
                this.inputFileUpload.id = this.userCreationResponseModel.Id;
                this.uploadFiles();
              }
              else {
                this.redirectToListingPage();
              }
            }
            else {
              this._toastService.addToast({ title: 'Error Occurred', msg: this.userCreationResponseModel.FailureMessage, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
            }
          });
        }
      }
    }
  }

  clearFeilds() {

    if (!this.IsEditMode) {
      this.router.navigate(['/market-snapshot'], { queryParams: { UserGuid: this.PrincipalUserGuid, opentab: 6 } });
    }
    else {
      this.router.navigate(['/market-snapshot'], { queryParams: { UserGuid: this.PrincipalUserGuid, opentab: 6 } });
    }
  }


  validateemail() {
    if ((this.validationService.isEmail(this.userInputModel.EmailAddress) == false) && !this.validationService.IsinValid(this.userInputModel.EmailAddress)) {
      this.emailValid = false;
      this.emailvalidation = "invalid Email address";
    }
    else {
      this.emailValid = true;
      this.emailvalidation = "";
    }
    if (this.validationService.IsinValid(this.userInputModel.EmailAddress)) {
      this.emailValid = false;
    }
  }
  isPassword(search: string): boolean {
    var searchfind: boolean;
    var regexp = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");
    searchfind = regexp.test(search);
    return searchfind;

  }
  IsinValid(value: any) {

    if (value == undefined || value == '' || value == null) {
      return true;
    }
    if (value.toString().trim().length <= 0) {
      return true;
    }
    if (!value) {
      return true;
    }
    return false;
  }

  setDefault(event: any, index: number) {

    if (event.target.checked) {
      this.DefaultIndexCount++;
    }
    else {
      this.DefaultIndexCount--;
    }
  }
  redirectToListingPage() {
    if (!this.IsEditMode) {
      this._toastService.addToast({ title: 'Success', msg: 'User Created Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
    }
    else {
      this.authService.reloadUserDetails(true);
      this._toastService.addToast({ title: 'Success', msg: 'User Details Updated Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
    }
    this.router.navigate(['/market-snapshot'], { queryParams: { UserGuid: this.PrincipalUserGuid, opentab: 6 } });
  }

  onRemoveImage(id: number) {
    if (id > 0) {
      //this._toastService.addToast({ title: 'Processing', msg: 'Please wait...', timeout: 2000, theme: 'bootstrap', position: 'top-center', type: 'wait' })
      this.loaderService.display(true);
      this._userManagerService.deleteImage(id).subscribe(response => {

        if (response.toString() === 'true') {
          this._toastService.addToast({
            title: 'Success',
            msg: 'Image deleted successfully!',
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'success'
          });
          this.loaderService.display(false);
          this.userInputModel.ProfilePicPath = '/../../../assets/img/default-profile-img.png';
          this.imageIdToDelete = null;
          $('.profileupload')[0].hidden = false;
          this.authService.reloadUserDetails(true);
        } else {
          this._toastService.addToast({
            title: 'Error Occurred',
            msg: 'Image could not be deleted',
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'error'
          });
        }

      });
    }
    else {
      this._toastService.addToast({
        title: 'Success',
        msg: 'Image deleted successfully!',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'success'
      });
    }
  }

  openModalForDelete(template: TemplateRef<any>, classes, taskId: number, task: string) {
    this.deleteTask = task;
    this.deleteTaskId = taskId;
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  enablePasswordInput = false;

  checkDuplicateUser() {
    this.modalRefGrandAccess = this.modalService.show(this.grandAccess, { class: 'deletemodal' });

  }
  changeStatus(type: number) {
    if (type == 1) {
      this.IsUserValid = false;
    }
    else {
      this.IsUserValid = true;
    }
    this.modalRefGrandAccess.hide();
  }
}
